<template>
  <div
    v-if="hasPrices"
    v-bind="$attrs"
    class="flex flex-row gap-3 text-xs text-gray-500 dark:text-gray-400"
  >
    <span
      v-for="price in lines"
      :key="price.key"
      :class="{
        'font-semibold text-gray-900 dark:text-white': price.applicable,
        'text-gray-400 dark:text-gray-500': price.greyed
      }"
    >
      {{ $t(`attributes.${price.key}`) }} :
      <AmountFormatter
        v-if="price.amount !== null"
        class="inline"
        :amount="price.amount"
      />
      <template v-else>-</template>
    </span>
  </div>
</template>

<script>
import AmountFormatter from '@c/AmountFormatter.vue'

/**
 * Both wiki prices of an item. When the API says which one applies for the
 * deceased (`price_type`: resident or non_resident), that one is emphasised
 * and the other one greyed out.
 */
export default {
  name: 'WikiItemPrices',
  inheritAttrs: false,
  components: { AmountFormatter },
  props: {
    wikiItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasPrices() {
      return (
        (this.wikiItem.price_resident ?? null) !== null ||
        (this.wikiItem.price_non_resident ?? null) !== null
      )
    },
    lines() {
      const applicable = this.wikiItem.price_type ?? null

      return ['resident', 'non_resident'].map((key) => ({
        key,
        amount: this.wikiItem[`price_${key}`] ?? null,
        applicable: applicable === key,
        greyed: applicable !== null && applicable !== key
      }))
    }
  }
}
</script>
